// extracted by mini-css-extract-plugin
export default {"button":"ButtonArrow_button__4y8TW"};